/**
 * Shared ReactModal content styles — fluid on small viewports, fixed cap on desktop.
 */

const baseContent = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  transform: "translate(-50%, -50%)",
  width: "min(420px, calc(100vw - 24px))",
  maxWidth: "calc(100vw - 24px)",
  maxHeight: "calc(100vh - 48px)",
  overflow: "auto",
  WebkitOverflowScrolling: "touch",
  borderRadius: "4px",
  outline: "none",
  margin: 0,
  boxSizing: "border-box",
};

/** Delete / confirm dialogs (~235px tall on desktop). */
export const confirmModalStyles = {
  content: {
    ...baseContent,
    height: "auto",
    minHeight: "min(235px, calc(100vh - 48px))",
  },
};

/**
 * Wider form modals (supplier wizard, etc.).
 *
 * NOTE: do not add `inset` here. `inset` is the shorthand for top/right/bottom/left,
 * and React serialises style keys in insertion order — so an `inset: "auto"` after
 * `baseContent` wiped the `top: 50%` / `left: 50%` centring, leaving the box at its
 * static position and then shifted by `translate(-50%, -50%)`, i.e. half off the top
 * left of the screen. That's why the New Supplier wizard appeared not to open.
 *
 * Overlay/content z-index is enforced in SCSS (`.rc-supplier-wizard-modal-overlay`)
 * because global `.ReactModal__Overlay { z-index: 1500 !important }` overrides
 * these inline values — without that, the wizard opens behind product preview
 * content (1600) and the New Supplier button looks broken.
 */
export const formModalStyles = {
  overlay: {
    zIndex: 1600,
    backgroundColor: "rgba(0, 0, 0, 0.65)",
  },
  content: {
    ...baseContent,
    width: "min(560px, calc(100vw - 24px))",
    height: "auto",
    maxHeight: "calc(100vh - 32px)",
    padding: 0,
    background: "#0b0b0b",
    border: "1px solid #242424",
    borderRadius: "14px",
  },
};

/** ContactWizard / New Supplier — matches /users/create layout width + dark shell. */
export const contactWizardModalStyles = {
  overlay: {
    zIndex: 1600,
    backgroundColor: "rgba(0, 0, 0, 0.72)",
  },
  content: {
    ...baseContent,
    width: "min(960px, calc(100vw - 24px))",
    height: "auto",
    maxHeight: "calc(100vh - 32px)",
    padding: 0,
    background: "#0b0b0b",
    border: "1px solid #242424",
    borderRadius: "14px",
    overflow: "auto",
  },
};

/** Centered filter / search modals. */
export const filterModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "90vh",
    maxWidth: "min(600px, calc(100vw - 24px))",
    width: "min(600px, calc(100vw - 24px))",
    minWidth: 0,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    padding: 0,
    boxSizing: "border-box",
  },
};
